import * as React from 'react';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { InquiryModes, InquiryType } from 'src/Library/Constants'
import { connect } from 'react-redux';
import { StylesProps } from 'src/Library/Types';
import { bindActionCreators } from 'redux';
import { Icon, Tooltip} from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { tokens } from 'src/design-system';

const styles = (theme: any) => ({
  inquiryDetailsCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 0px',
    borderBottom: '1px solid #CCCCCC',
  },
  infoTextStyle: {
    paddingTop: '5px',
    fontSize: `${tokens.fontSize.caption}px`,
    color: '#838383',
  },
  inquiryDetailsHeaderStyles: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 0px 0px 0px',
    fontSize: `${tokens.fontSize.small}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#262626',
  },
  locationDetails: {
    color: '#262626',
    fontSize: '13px',
    maxWidth: '30px',
    fontWeight: tokens.fontWeight.regular,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
});

interface IProps extends StylesProps<ReturnType<typeof styles>>, FormComponentProps {
  selectedItems : Record<string, any>;
  timezone?: string;
}

const DisplaySelectedInquiries = (props: IProps) => {
  const {
    classes,
    selectedItems,
    timezone,
  } = props;

  const totalInquiries = Object.keys(selectedItems)?.length;
  const maxNameLength = 14;

  const renderInquiryDetailsHeader = () =>{
    return (
      <div
      className = {classes.inquiryDetailsHeaderStyles}
      >
        <span>{totalInquiries} Inquiries selected</span>
        <span>Current Deadline</span>
      </div>
    )
  }

  const renderDeadline = (deadline) => {
    if (!deadline) return null;
    
    // Convert deadline to organization timezone for display
    const deadlineMoment = timezone
      ? momentTimezone(deadline).tz(timezone)
      : moment(deadline);
    
    // For time comparisons, use UTC to ensure accuracy
    const deadlineUtc = moment(deadline);
    const now = moment();
    
    if (deadlineUtc < now){
      return (
        <div style={{textAlign:'right', color:tokens.colors.text, fontSize:'13px'}}>
          {deadlineMoment.format('DD MMMM, YYYY | HH:mm')}
          
        </div>
      )
    } else if (deadlineUtc.diff(now, 'hours')<=48){
      return (
        <div style={{textAlign:'right', color:'#EC4522', fontSize:'13px'}}>
          {deadlineUtc.diff(now, 'hours')} hours left
        </div>
      )
    } else {
      return (
      <div style={{textAlign:'right', color:tokens.colors.text, fontSize: '13px'}}>
        {deadlineUtc.diff(now, 'days')} days left
      </div>
    )}
  }

  const renderCreatedAt = (createdAt) => {
    return (
      <div 
      className={classes.infoTextStyle}
      style={{textAlign:'right'}}>
        {moment(createdAt).format('DD MMMM, YYYY | HH:mm')}
      </div>
    )
  }

  const renderReferenceNumber = (referenceNumber) => {
    return (
      <div 
      className={classes.infoTextStyle}
      style={{fontStyle: 'italic'}}>
        {referenceNumber}
      </div>
    )
  }

  const renderOriginDetails = (inquiry) => {
    const { mode, inquiryMode, originLocationDetails, originPortDetails } = inquiry;
    let originDetails = "";
    if (mode === InquiryModes.TRAILER || inquiryMode === InquiryModes.TRAILER || mode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.DOMESTIC){
      originDetails = originLocationDetails?.city || originLocationDetails?.name;
    } else {
      originDetails = originPortDetails?.name;
    }
     return (
       <Tooltip title={originDetails} placement="topLeft">
         <span className={classes.locationDetails}>
           {originDetails}
         </span>
       </Tooltip>
     );
  }

  const renderDestinationDetails = (inquiry) => {
    const { mode, inquiryMode, type, inquiryType, destinationLocationDetails, destinationPortDetails } = inquiry;
    let destinationDetails = "";
    if (mode === InquiryModes.TRAILER || inquiryMode === InquiryModes.TRAILER) {
      const destination =
        type === InquiryType.EXPORT || inquiryType === InquiryType.EXPORT
          ? destinationPortDetails || inquiry.destination
          : destinationLocationDetails;
      destinationDetails =
        type === InquiryType.EXPORT || inquiryType === InquiryType.EXPORT
          ? destination?.name
          : destination?.city || destination?.name;
    } else if (mode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.DOMESTIC) {
      destinationDetails = destinationLocationDetails?.city || destinationLocationDetails?.name;
    } else {
      destinationDetails = destinationPortDetails?.name;
    }
    return (
      <Tooltip title={destinationDetails} placement="topLeft">
        <span className={classes.locationDetails}>
          {destinationDetails}
        </span>
      </Tooltip>
    )
  }

  const renderOriginAndDestinationDetails = (inquiry) => {
    return (
      <div>
        {renderOriginDetails(inquiry)}
        <Icon type="arrow-right" 
          style={{padding: '0px 10px'}}
        />
        {renderDestinationDetails(inquiry)}
      </div>
    )
  }

  const renderInquiries = () => {
    return (
      Object.values(selectedItems).map(inquiry => {
        return (
          <div className={classes.inquiryDetailsCard}>
            <div>
              {renderOriginAndDestinationDetails(inquiry)}
              {renderReferenceNumber(inquiry?.referenceNumber)}
            </div>
            <div>
              {renderDeadline(inquiry?.deadline)}
              {renderCreatedAt(inquiry?.createdAt)}
            </div>
          </div>
        )
      })
    )
  }

  return (
    <div>
        {renderInquiryDetailsHeader()}
        {renderInquiries()}
    </div>
  );
};

const mapStateToProps = ({masterData, inquiryShipperReducer}) => ({
  selectedItems : inquiryShipperReducer.selectedItems || {},
  timezone: masterData.timezone,
});
const mapDispatchToProps = dispatch => (bindActionCreators({
}, dispatch));

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(DisplaySelectedInquiries)));
